import React from "react";
import {ImageButton} from "../imageButton/ImageButton";

interface ButtonProps {
    disabled?: boolean
    handleClick: () => void
}

export const ArchiveButton: React.FC<ButtonProps> = ({
                                                         disabled = false,
                                                         handleClick
                                                     }) => {
    return <ImageButton
        disabled={disabled}
        onClick={handleClick}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 9.75H19.5V18.3107L18.3107 19.5H5.68934L4.5 18.3107L4.5 9.75H3V4.5H21V9.75ZM6 9.75L18 9.75V17.6893L17.6893 18H6.31066L6 17.6893L6 9.75ZM19.5 6V8.25L4.5 8.25L4.5 6L19.5 6ZM9.75 13.5H15V12H9.75V13.5Z"
                  fill="currentColor"/>
        </svg>
    </ImageButton>
}
